<!--维修订单页面-->
<template>
    <div>

        <div>
            <van-sticky><!-- 粘性布局，顶部的位置固定 -->
                <div class="conopen" style="background-color: #f8f8f9">

                    <van-row type="flex" justify="space-between">
                        <van-col span="3">

                            <div style="padding: 17px">
                                <van-icon name="arrow-left" size="15px" @click="onback"/><!-- icon图标，返回路劲 -->
                            </div>
                        </van-col>
                        <van-col span="18">
                            <!-- 搜索组件 -->
                            <form action="/">
                                <van-search
                                        style="width: 100%;"
                                        v-model="value"
                                        placeholder="车牌号\车架号"
                                        show-action
                                        @search="onFind"
                                >
                                    <div slot="action" @click="onFind">搜索</div>
                                </van-search>
                            </form>
                        </van-col>
                        <van-col span="3">
                            <div style="padding: 17px">
                                <!-- icon图标，刷新页面 -->
                                <van-icon name="replay" size="15px" @click="reststart"/>
                            </div>
                        </van-col>

<!--                        <van-col span="3">-->
<!--                            <div style="padding: 17px">-->
<!--                                <van-icon name="plus" size="15px" @click="addMaintainOrderModal=true"/>-->
<!--                                &lt;!&ndash; icon图标，创建订单页面 &ndash;&gt;-->
<!--                                &lt;!&ndash;                                <Button type="primary" size="small" style="margin-right: 3px;" @click="addMaintainOrderModal=true">添加维修订单</Button>&ndash;&gt;-->
<!--                            </div>-->
<!--                        </van-col>-->

                    </van-row>

                </div>
                <div>
                    <!-- 下拉菜单 -->
                    <van-dropdown-menu>
                        <van-dropdown-item v-model="value1" :options="option1" @change="getNew"/>
                        <van-dropdown-item v-model="value2" :options="option2" @change="open"/>
                    </van-dropdown-menu>
                </div>
            </van-sticky>

        </div>

        <div style="background-color: #f8f8f9">
            <van-pull-refresh v-model="isLoading" @refresh="refresh"><!-- 下拉刷新 -->
                <!-- 上拉加载 -->
                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                >
                    <!-- 加载图标 -->
                    <van-loading class="loader" v-if="loader"/>
                    <div v-for="(item,index) in maintainOrderslist" class="content">
                        <Card style="width:100%">
                            <label>订单号:
                                <label style="color: #0077aa;">{{item.orderNum}}</label>
                            </label><br/>
                            <div class="mid">
                                <span class="count fl">车牌号:
                                    <label style="color: #0077aa;">{{item.vehicleInfo==null?'':item.vehicleInfo.registrationNum}}</label>
                                    <!--                                    <label style="color: #0077aa;">{{item.tempVehicleInfo.registrationNum}}</label>-->
                                </span>
                                <span class="distance fr">|</span>
                                <span class="time fr">车架号:
                                                                <label style="color: #0077aa;">{{item.vehicleInfo==null?'':item.vehicleInfo.vin}}</label>
                                                            </span>
                            </div>
                            <div class="mid">
                                <span class="count fl">发动机号:
                                    <label style="color: #0077aa;">{{item.vehicleInfo==null?'':item.vehicleInfo.engineNum}}</label>
                                </span>
                            </div>
                            <div class="mid">
                                <span class="time fr">问题描述:
                                    <label style="color: #0077aa;">{{item.question==null?'':item.question}}</label>
                                </span>
                            </div>
                            <div class="mid">
                                <span class="count fl">预约维修时间:
                                    <label style="color: #0077aa;">{{item.bookingDatetime==null?'':new Date(item.bookingDatetime).Format('yyyy年MM月dd日')}}</label>
                                </span>
                            </div>

                            <div class="mid">
                                                            <span class="count fl">客户姓名:
                                                                <label style="color: #0077aa;">{{item.vehicleInfo.clientInfo==null?'':item.vehicleInfo.clientInfo.name}}</label>
                                                                <!--                                    <label style="color: #0077aa;">{{item.tempVehicleInfo.registrationNum}}</label>-->
                                                            </span>
                                <span class="distance fr">|</span>
                                <span class="time fr">客户电话:
                                                                <label style="color: #0077aa;">{{item.vehicleInfo.clientInfo==null?'':item.vehicleInfo.clientInfo.phoneNum}}</label>
                                                            </span>
                            </div>
                            <div class="mid">
                                                            <span class="count fl">客户地址:
                                                                <label style="color: #0077aa;">{{item.vehicleInfo.clientInfo==null?'':item.vehicleInfo.clientInfo.address}}</label>
                                                                <!--                                    <label style="color: #0077aa;">{{item.tempVehicleInfo.registrationNum}}</label>-->
                                                            </span>
                            </div>
                            <div class="mid">
                                <span class="count fl">备注:
                                    <label style="color: #fc0000;">{{item.remark==null?'':item.remark}}</label>
                                </span>
                            </div>
                            <div class="mid">
                                <span class="count fl">公司联系人:
                                    <label style="color: #0077aa;">{{item.createUser==null?'':item.createUser.nickName}}</label>
                                    <!--                                    <label style="color: #0077aa;">{{item.tempVehicleInfo.registrationNum}}</label>-->
                                </span>
                                <span class="distance fr">|</span>
                                <span class="time fr">公司联系人电话:
                                    <label style="color: #0077aa;">{{item.createUser==null?'':item.createUser.mobilePhoneNum}}</label>
                                </span>
                            </div>
                            <div class="mid">
                                <span class="count fl">订单业务员:
                                    <label style="color: #0077aa;">{{item.businessUser==null?'':item.businessUser.nickName}}</label>
                                    <!--                                    <label style="color: #0077aa;">{{item.tempVehicleInfo.registrationNum}}</label>-->
                                </span>
                                <span class="distance fr">|</span>
                                <span class="time fr">订单业务员电话:
                                    <label style="color: #0077aa;">{{item.businessUser==null?'':item.businessUser.mobilePhoneNum}}</label>
                                </span>
                            </div>
                            <div class="mid">
                                <span class="count fl">订单维修员:
                                    <label style="color: #0077aa;">{{item.maintainer==null?'':item.maintainer.nickName}}</label>
                                    <!--                                    <label style="color: #0077aa;">{{item.tempVehicleInfo.registrationNum}}</label>-->
                                </span>
                                <span class="distance fr">|</span>
                                <span class="time fr">订单维修员电话:
                                    <label style="color: #0077aa;">{{item.maintainer==null?'':item.maintainer.mobilePhoneNum}}</label>
                                </span>
                            </div>
                            <div class="mid">
                                <span class="count fl">订单状态:
                                    <label style="color: #0077aa;">{{item.state==0?'作废':item.state==1?'待指派':item.state==2?'待维修':'维修完成'}}</label>
                                </span>
                                <span class="distance fr">|</span>
                                <span class="time fr">维修结果:
                                    <label style="color: #0077aa;">{{item.result==null?'':item.result}}</label>
                                </span>
                            </div>
                            <div class="mid">
                                <Button size="small" type="info" @click="tomaintainOrdersDetail(item)">订单详细
                                </Button>&nbsp;
<!--                                <Button size="small" type="info" @click="assignMaintenance(item)">指派维修员-->
<!--                                </Button>&nbsp;-->
<!--                                <Button size="small" type="info" @click="assignSalesman(item)">指定跟进业务-->
<!--                                </Button>&nbsp;-->
                                <a :href="'../maintainOrders-UploaderImage-vant?maintainOrdersUploaderimage='+item.id">
                                <Button size="small" type="info" @click="toUploadermaintainOrdersDetail(item)">上传图片
                                </Button>&nbsp;
                                </a>
                            </div>
                            <div class="mid">
                                <Button size="small" type="info" @click="showmodel(item)">添加维修记录
                                </Button>&nbsp;
                                <Button size="small" type="info" @click="showdeletemodel(item)">删除维修记录
                                </Button>&nbsp;
                                <Button size="small" type="info" @click="showmodel1(item)">确认维修
                                </Button>&nbsp;
                            </div>

                        </Card>
                        <div style="height: 3px"></div>
                        <!-- 分割线组件 -->
                        <!--                <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }">-->
                        <!--                </van-divider>-->
                    </div>


                </van-list>
            </van-pull-refresh>
        </div>

        <!--<div>-->
        <!--        <Modal-->
        <!--                v-model="modal1"-->
        <!--                title="完成维修"-->
        <!--                @on-ok="ok"-->
        <!--                @on-cancel="cancel">-->
        <!--            <Form ref="maintainDeviceRecordRef" :model="maintainDeviceRecord" :label-width="50">-->
        <!--                <FormItem prop="content" label="主机号">-->
        <!--                    <Select v-model="selectDevice">-->
        <!--                        <Option v-for="item in devices" :value="item.terminalNum" :key="item.terminalNum">{{item.terminalNum}}</Option>-->
        <!--                    </Select>-->
        <!--                </FormItem>-->
        <!--                <FormItem label="操作">-->
        <!--                    <Checkbox :disabled="maintainDeviceRecord.removeDevice" v-model="maintainDeviceRecord.changeDevice"><span>更换设备</span></Checkbox>-->
        <!--                    <Checkbox :disabled="maintainDeviceRecord.removeDevice" v-model="maintainDeviceRecord.changeSim"><span>更换SIM卡</span></Checkbox>-->
        <!--                    <Checkbox :disabled="maintainDeviceRecord.changeDevice || maintainDeviceRecord.changeSim"-->
        <!--                              v-model="maintainDeviceRecord.removeDevice"><span>拆除设备</span></Checkbox>-->
        <!--                </FormItem>-->
        <!--                <FormItem v-if="maintainDeviceRecord.changeSim" prop="newTerminalNum" label="新设备主机号">-->
        <!--                    <Input v-model="maintainDeviceRecord.newTerminalNum"></Input>-->
        <!--                </FormItem>-->
        <!--                <FormItem v-if="maintainDeviceRecord.changeDevice" prop="newFactoryTerminalNum" label="新设备出厂主机号">-->
        <!--                    <Input v-model="maintainDeviceRecord.newFactoryTerminalNum"></Input>-->
        <!--                </FormItem>-->
        <!--                <FormItem v-if="maintainDeviceRecord.changeDevice" prop="newPositioningDeviceModel" label="新设备型号">-->
        <!--                    <Input v-model="maintainDeviceRecord.newPositioningDeviceModel"></Input>-->
        <!--                </FormItem>-->
        <!--            </Form>-->
        <!--        </Modal>-->
        <!--</div>-->

        <!--    添加维修订单    -->
        <!--            <add-maintain-order-modal v-model="addMaintainOrderModal" @on-success="onSuccess"></add-maintain-order-modal>-->
        <add-maintain-order-modal v-model="addMaintainOrderModal"></add-maintain-order-modal>
<!--        &lt;!&ndash;    指派维修员    &ndash;&gt;-->
<!--        <maintain-order-change-maintainer-modal v-model="maintainOrderChangeMaintainerModal"-->
<!--                                                :initValue="maintainOrderChangeMaintainerId"-->
<!--                                                @on-success="refresh"></maintain-order-change-maintainer-modal>-->
<!--        &lt;!&ndash;    指点业务员    &ndash;&gt;-->
<!--        <maintain-order-change-business-user-modal v-model="changeBusinessUserModal" :initValue="changeBusinessUserId"-->
<!--                                                   @on-success="refresh"></maintain-order-change-business-user-modal>-->
        <!--   添加维修记录     -->
        <maintain-order-add-maintain-device-record-modal v-model="maintainOrderAddMaintainDeviceRecordModal"
                                                         :initValue="maintainOrderAddMaintainDeviceRecordId"
                                                         @on-success="refresh"></maintain-order-add-maintain-device-record-modal>
        <!--   删除维修记录     -->
        <maintain-order-delete-maintain-device-record-modal v-model="maintainOrderDeleteMaintainDeviceRecordModal"
                                                            :initValue="maintainOrderDeleteMaintainDeviceRecordId"
                                                            @on-success="refresh"></maintain-order-delete-maintain-device-record-modal>
        <!--   修改维修记录     -->
        <maintain-order-modify-maintain-device-record-modal v-model="maintainOrderModifyMaintainDeviceRecordModal"
                                                         :initValue="maintainOrderModifyMaintainDeviceRecordId"
                                                         @on-success="refresh"></maintain-order-modify-maintain-device-record-modal>
    </div>
</template>

<script>
    import Vue from 'vue'
    import store from '@/store'
    import {genQueryParam, genSortParam} from '@/libs/queryparamhelper'

    import MaintainOrderAddMaintainDeviceRecordModal
        from '../maintainOrders/components/maintain-order-add-maintain-device-record-modal'
    import MaintainOrderDeleteMaintainDeviceRecordModal
        from '../maintainOrders/components/maintain-order-delete-maintain-device-record-modal'
    import MaintainOrderModifyMaintainDeviceRecordModal
        from '../maintainOrders/components/maintain-order-modify-maintain-device-record-modal'
    import AddMaintainOrderModal from '../maintainOrders/components/add-maintain-order-modal'
    import MaintainOrderChangeBusinessUserModal
        from '../maintainOrders/components/maintain-order-change-business-user-modal'
    import MaintainOrderChangeMaintainerModal from '../maintainOrders/components/maintain-order-change-maintainer-modal'
    import {
        Cell,
        CellGroup,
        Field,
        Row,
        Col,
        Button,
        Dialog,
        Radio,
        RadioGroup,
        Checkbox,
        CheckboxGroup,
        Picker,
        Popup,
        Divider,
        Collapse,
        CollapseItem,
        DatetimePicker,
        Tag,
        DropdownMenu,
        DropdownItem,
        Sticky,
        Icon,
        Search,
        PullRefresh,
        List,
        Loading,
        Toast,
        NumberKeyboard,
    } from 'vant'


    Vue.use(Cell).use(CellGroup).use(Field).use(Row).use(Col).use(Button).use(Dialog).use(Radio).use(Tag).use(DropdownMenu).use(NumberKeyboard)
        .use(RadioGroup).use(Checkbox).use(CheckboxGroup).use(Picker).use(Popup).use(Divider).use(Collapse).use(CollapseItem)
        .use(DatetimePicker).use(Icon).use(DropdownItem).use(Sticky).use(Search).use(PullRefresh).use(List).use(Loading).use(Toast);

    export default {
        name: "maintainOrders",
        components: {
            MaintainOrderAddMaintainDeviceRecordModal,
            MaintainOrderDeleteMaintainDeviceRecordModal,
            MaintainOrderModifyMaintainDeviceRecordModal,
            AddMaintainOrderModal,
            MaintainOrderChangeBusinessUserModal,
            MaintainOrderChangeMaintainerModal
        },
        data() {
            return {
                //搜索
                value: null,

                value1: 1,
                option1: [
                    {text: '新版页面', value: 0},
                    {text: '旧版页面', value: 1},
                ],
                value2: 2,
                option2: [
                    {text: '全部', value: -2},
                    {text: '作废', value: 0},
                    {text: '待指派', value: 1},
                    {text: '待维修', value: 2},
                    {text: '维修完成', value: 3},
                    {text: '异常', value: -1},
                ],

                //增加维修订单
                addMaintainOrderModal: false,

                // 增加设备维修记录
                maintainOrderAddMaintainDeviceRecordModal: false,
                maintainOrderAddMaintainDeviceRecordId: null,

                // 删除设备维修记录
                maintainOrderDeleteMaintainDeviceRecordModal: false,
                maintainOrderDeleteMaintainDeviceRecordId: null,

                // 修改设备维修记录
                maintainOrderModifyMaintainDeviceRecordModal: false,
                maintainOrderModifyMaintainDeviceRecordId: null,

                // 指定业务跟进
                changeBusinessUserModal: false,
                changeBusinessUserId: null,

                // 指派维修员
                maintainOrderChangeMaintainerModal: false,
                maintainOrderChangeMaintainerId: null,

                //车辆设备列表
                devices: [],
                //修改表单
                maintainDeviceRecord: {
                    terminalNum: null,
                    newTerminalNum: null,
                    newFactoryTerminalNum: null,
                    newPositioningDeviceModelId: null,
                    changeDevice: false,
                    changeSim: false,
                    removeDevice: false,
                    positioningDeviceInfoId: null,
                    positioningDeviceInfo: null,
                    result: null,
                    maintainOrderId: null,
                },

                maintainOrderslist: [],
                i: [],
                loading: false,
                finished: false,
                loader: false,
                isLoading: false,

                modal1: false,
            }
        },
        methods: {
            ok() {
            },
            cancel() {
            },

            refresh() {
                setTimeout(() => {
                    this.i = []
                    this.maintainOrderslist = []
                    this.finished = false;
                    this.onLoad()
                    this.isLoading = false;
                }, 500);
            },
            /**
             *  前往新版本页面
             */
            getNew(){
                if (this.value1 == 0 ) {
                    this.$router.push({
                        name: 'installermaintainorder',
                    })
                }
            },
            /**
             * 调用分页方法
             */
            open() {
                this.i = []
                this.maintainOrderslist = []
                this.finished = false;
                this.onLoad()
            },
            //安装维修员
            getMyMaintainPage(e) {
                this.i.push(1)
                let bb
                let queryParams = []
                if (e != -2){
                    queryParams.push(genQueryParam('state', 'EQ', e))
                }
                store.dispatch('MaintainOrderServ_GetMyMaintainPage', {
                    params: null,
                    urlparams: {
                        q: queryParams,
                        p: this.i.length,
                        keyword: this.value,
                        sort: genSortParam('createDatetime', false)
                    }
                }).then((res) => {
                    console.log(res)
                    if (res.data.content.length != 0) {
                        for (let j = 0; j < res.data.content.length; j++) {
                            this.maintainOrderslist.push(res.data.content[j]);
                        }
                        bb = res.data.totalElements
                        // this.maintainOrderslist = res.data.content
                        // 加载状态结束
                        this.loading = false;

                        // 数据全部加载完成
                        if (this.maintainOrderslist.length >= bb) {
                            this.finished = true;
                        }
                    } else {
                        // 加载状态结束
                        this.loading = false;
                        this.finished = true;

                    }
                }).catch((err) => {
                    // 加载状态结束
                    this.loading = false;
                    this.finished = true;
                    Toast(err)
                    console.log(err)
                })
            },
            //业务员
            getMyUserGroupPage(e) {
                this.i.push(1)
                let bb
                let queryParams = []
                if (e != -2){
                    queryParams.push(genQueryParam('state', 'EQ', e))
                }
                store.dispatch('MaintainOrderServ_GetMyBusinessPage', {
                    params: null,
                    urlparams: {
                        q: queryParams,
                        p: this.i.length,
                        keyword: this.value,
                        sort: genSortParam('createDatetime', false)
                    }
                }).then((res) => {
                    console.log(res)
                    if (res.data.content.length != 0) {
                        for (let j = 0; j < res.data.content.length; j++) {
                            this.maintainOrderslist.push(res.data.content[j]);
                        }
                        bb = res.data.totalElements
                        // this.maintainOrderslist = res.data.content
                        // 加载状态结束
                        this.loading = false;

                        // 数据全部加载完成
                        if (this.maintainOrderslist.length >= bb) {
                            this.finished = true;
                        }
                    } else {
                        // 加载状态结束
                        this.loading = false;
                        this.finished = true;

                    }
                }).catch((err) => {
                    // 加载状态结束
                    this.loading = false;
                    this.finished = true;
                    Toast(err)
                    console.log(err)
                })
            },
            getPage(e) {
                this.i.push(1)
                let bb
                let queryParams = []
                if (e != -2){
                    queryParams.push(genQueryParam('state', 'EQ', e))
                }
                store.dispatch('MaintainOrderServ_GetMyMaintainPage', {
                    params: null,
                    urlparams: {
                        q: queryParams,
                        p: this.i.length,
                        keyword: this.value,
                        sort: genSortParam('createDatetime', false)
                    }
                }).then((res) => {
                    console.log(res)
                    if (res.data.content.length != 0) {
                        for (let j = 0; j < res.data.content.length; j++) {
                            this.maintainOrderslist.push(res.data.content[j]);
                        }
                        bb = res.data.totalElements
                        // this.maintainOrderslist = res.data.content
                        // 加载状态结束
                        this.loading = false;

                        // 数据全部加载完成
                        if (this.maintainOrderslist.length >= bb) {
                            this.finished = true;
                        }
                    } else {
                        // 加载状态结束
                        this.loading = false;
                        this.finished = true;

                    }
                }).catch((err) => {
                    // 加载状态结束
                    this.loading = false;
                    this.finished = true;
                    Toast(err)
                    console.log(err)
                })
            },


            //下拉加载
            onLoad() {
                // console.log(this.value1)
                console.log(this.value2)
                // if (this.value1 == 0) {
                if (this.value2 == -2) {
                    //全部
                    this.getMyMaintainPage(-2)
                }else if (this.value2 == 0) {
                        //作废
                        this.getMyMaintainPage(0)
                    } else if (this.value2 == 1) {
                        //待指派
                        this.getMyMaintainPage(1)
                    } else if (this.value2 == 2) {
                        //待维修
                        this.getMyMaintainPage(2)
                    } else if (this.value2 == 3) {
                        //已完成
                        this.getMyMaintainPage(3)
                    } else {
                        //异常
                        this.getMyMaintainPage(-1)
                    }
                // } else if (this.value1 == 1) {
                //     if (this.value2 == 0) {
                //         //作废
                //         this.getMyUserGroupPage(0)
                //     } else if (this.value2 == 1) {
                //         //待指派
                //         this.getMyUserGroupPage(1)
                //     } else if (this.value2 == 2) {
                //         //待维修
                //         this.getMyUserGroupPage(2)
                //     } else if (this.value2 == 3) {
                //         //已完成
                //         this.getMyUserGroupPage(3)
                //     } else {
                //         //异常
                //         this.getMyUserGroupPage(-1)
                //     }
                // } else if (this.value1 == 2) {
                //     if (this.value2 == 0) {
                //         //作废
                //         this.getPage(0)
                //     } else if (this.value2 == 1) {
                //         //待指派
                //         this.getPage(1)
                //     } else if (this.value2 == 2) {
                //         //待维修
                //         this.getPage(2)
                //     } else if (this.value2 == 3) {
                //         //已完成
                //         this.getPage(3)
                //     } else {
                //         //异常
                //         this.getPage(-1)
                //     }
                // }
            },
            //弹出确认框
            showmodel(e) {
                console.log(e)
                this.maintainOrderAddMaintainDeviceRecordModal = true
                this.maintainOrderAddMaintainDeviceRecordId = e.id
                // this.maintainDeviceRecord.maintainOrderId = e.id
                // store.dispatch('MaintainOrderServ_GetCanMakeRecordDevices', {
                //     params: {id: e.id},
                //     urlparams: null
                // }).then(() => {
                //     let devices = store.getters.get_MaintainOrder_GetCanMakeRecordDevicesResult
                //     console.log(devices)
                //     if (devices) {
                //         this.devices = devices
                //     }
                // }).catch(err => {
                //     this.$Message.error(err)
                // })
            },
            //弹出删除框
            showdeletemodel(e){
                this.maintainOrderDeleteMaintainDeviceRecordModal= true,
                    this.maintainOrderDeleteMaintainDeviceRecordId= e.id
            },
            showmodel1(e){
                console.log(e)
                this.maintainOrderModifyMaintainDeviceRecordModal = true
                this.maintainOrderModifyMaintainDeviceRecordId = e.id
                this.onLoad()
            },
            //指定业务员
            assignSalesman(e) {
                this.changeBusinessUserModal = true
                this.changeBusinessUserId = e.id
            },
            //指派维修员
            assignMaintenance(e) {
                this.maintainOrderChangeMaintainerModal = true
                this.maintainOrderChangeMaintainerId = e.id
            },
            //上传图片页
            toUploadermaintainOrdersDetail(e) {
                // this.$router.push({
                //     // name: 'maintainOrders-Uploaderimage',
                //     name: 'maintainOrders-UploaderImage-vant',
                //     query: {'maintainOrdersUploaderimage': e.id}
                // })
            },
            //订单详细
            tomaintainOrdersDetail(e) {
                console.log(e)
                this.$router.push({
                    name: 'maintainOrdersDetail',
                    params: {'maintainOrdersDetailid': e.id}
                })
            },
            // <!-- icon返回路劲 -->
            onback() {
                this.$router.push({
                    name: 'myMenu'
                })
            },
            // <!-- icon图标刷新方法 -->
            reststart() {
                this.loader = true
                setTimeout(() => {
                    // this.check()
                    this.i = []
                    this.maintainOrderslist = []
                    this.finished = false;
                    this.onLoad()
                    this.loader = false
                }, 500);
            },
            // <!-- 搜索方法 -->
            onFind() {
                this.i = []
                this.maintainOrderslist = []
                this.finished = false;
                this.onLoad()
            },
        },
        mounted() {
            // store.dispatch('MaintainOrderServ_GetMyBusinessPage', {
            //     params: null,
            //     urlparams: null
            // }).then((res) => {
            //     console.log(res)
            // }).catch((err) => {
            //     console.log(err)
            // })
            this.onLoad()
        }
    }
</script>

<style scoped>
    /*右侧内容*/
    .content {
        /*background-color: red;*/
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: 0 15px 0 10px;
    }

    .content .name {
        font-size: 17px;
        color: #333;
        overflow: hidden;
        font-weight: bold;
        overflow: hidden;
    }

    /*月售、送达时间、距离*/
    .content .mid {
        flex: 1;
        margin-top: 7px;
        color: #666;
        font-size: 12px;
    }

    .conopen {
        text-align: right;
    }

    .loader {
        text-align: center;
    }

    .wrapper {
        width: 100%;
        height: 80%;
        position: absolute;
        top: 115px;
        bottom: 50px; /*关键*/
        overflow: hidden;
        z-index: 1;
    }
</style>
